module.exports = __webpack_public_path__ + "img/details-one.15bb5b59.png";